module.exports = { ...require('./serviceMetadata'), ...require('./serviceMarkup') };
